const Glide = require('@glidejs/glide').default as any;

export default (async () => {

  console.log('Loaded');



  let discFlightPathController = document.querySelector('.fp-img');
  let discFlightPathOpen = document.querySelector('.fp-container');
  let body = document.querySelector('body');
  let flightPathLargeImg = document.querySelector('.fp-img-lrg')

  if (discFlightPathController && discFlightPathOpen) {
    discFlightPathController.addEventListener("click", () => {
      toggleLightBox();
    });
  }


  if (discFlightPathController && discFlightPathOpen) {
    discFlightPathOpen.addEventListener("click", () => {
      toggleLightBox();
    });
  }


  function toggleLightBox() {
    if (discFlightPathOpen) {
      discFlightPathOpen.classList.toggle('show-fp');
    }
    body?.classList.toggle('hidden-overflow-y');
  }

  let mobileNavToggler = document.querySelector<HTMLSelectElement>('.mobilenav-toggler');
  let mobileNavMenu = document.querySelector<HTMLSelectElement>('.mobile-nav-container');
  let mobileNavClose = document.querySelector<HTMLSelectElement>('#close-menu');
  let bodyTag = document.body;


  if (mobileNavToggler != null) {
    mobileNavToggler.addEventListener("click", toggleMenu);
  }

  if (mobileNavClose != null) {
    mobileNavClose.addEventListener("click", toggleMenu);
  }



  function toggleMenu() {

    if (mobileNavToggler != null && mobileNavMenu != null) {
      mobileNavToggler.classList.toggle("nav-close");
      mobileNavMenu.classList.toggle("show-menu");
      bodyTag.classList.toggle("mobile-menu--opened");
    }
  }


  
  function stickyHeader() {
    const header = document.getElementById("header-navigation-container");
    let mainContent = document.getElementById("MainContent");



    if (header && mainContent) { 
     //   console.log("sticky:" + header.offsetTop);
     //  console.log("offset: " + window.pageYOffset);
      let headerHeight = header.clientHeight;
    //  console.log("Header Height : " + headerHeight);

      if (window.pageYOffset > header.offsetTop) {
        header.classList.add("sticky");
        mainContent.setAttribute("style", "margin-top: " + headerHeight + "px;");
      } else {
        header.classList.remove("sticky");
        mainContent.setAttribute("style", "margin-top: unset;");
      }
    }
  }
  window.addEventListener('scroll', stickyHeader);
  



  let parentLinks = document.querySelectorAll('.parent-link');
  let childLists = document.querySelectorAll('.child-list');

  if (parentLinks) {
    [...parentLinks].forEach((parentLink) => {
      parentLink.addEventListener("click", () => {
        let currentMenuLink = parentLink.getAttribute('parent-link');

        parentLink.classList.toggle('selected-link');

        for (var l = 0; l < childLists.length; l++) {
          let currentChildList = childLists[l].getAttribute('child-links');
          if (currentChildList === currentMenuLink) {
            childLists[l].classList.toggle('show-list');
          }
          else {
            childLists[l].classList.remove('show-list');
          }
        }

        for (var x = 0; x < parentLinks.length; x++) {
          let currentMenuLinkAlt = parentLinks[x].getAttribute('parent-link');
          if (currentMenuLinkAlt !== currentMenuLink) {
            parentLinks[x].classList.remove('selected-link');
          }
        }

      })
    })
  }

  // New Mobile Navigation - Drawers


let header = document.querySelector('#shopify-section-header');
let announcementBar = document.querySelector('#shopify-section-announcement-bar');
let mobileNavigationMenuContainer = document.querySelector<HTMLSelectElement>('.mobile-nav-container');

function checkHeaderHeight() {
  if (header && mobileNavigationMenuContainer) {
    let headerHeight = header?.clientHeight;
    let announcementBarHeight = 0; 
    if (announcementBar) {
      announcementBarHeight = announcementBar.clientHeight;
    }
    let totalHeaderHeight = headerHeight + announcementBarHeight; 
  
    mobileNavigationMenuContainer.setAttribute("style", "padding-top: " + totalHeaderHeight + "px; height: calc(100vh - " + totalHeaderHeight + "px);");
  
  }
}
window.addEventListener('resize', checkHeaderHeight);

  let mobileNavigationMenu = document.querySelector<HTMLSelectElement>('.mobile-nav-links');
  let closeMobileMenuDrawerButtons = document.querySelectorAll<HTMLSelectElement>('.menu-drawer-close');
  let mobileMenuFooter = document.querySelector<HTMLSelectElement>('.mobile-drawer-footer');


  let navGroups = document.querySelectorAll<HTMLSelectElement>('.has-sub-nav');
  let toplevelNavs = document.querySelectorAll<HTMLSelectElement>('.mobile-top-level');
  let navDrawers = document.querySelectorAll<HTMLSelectElement>('.sub-menu-drawer');

  if (navGroups != null) {

    for (let toplevelNav of toplevelNavs) {
      toplevelNav.addEventListener("click", event => {
        let navGroupNum = toplevelNav.getAttribute('top-level');

        for (var x = 0; x <= navDrawers.length; x++) {
          let navDrawerNum = navDrawers[x].getAttribute('drawer');
          if (navDrawerNum === navGroupNum) {
            navDrawers[x].classList.add('nav-open');
            mobileNavigationMenu?.classList.add('sub-menu-open'); 
            mobileMenuFooter?.classList.add('hidden');
          }
        }
      })
    }
  }

  if (closeMobileMenuDrawerButtons) {
    for (let closeMobileMenuDrawerButton of closeMobileMenuDrawerButtons) { 
      closeMobileMenuDrawerButton.addEventListener("click", event => {

        if (closeMobileMenuDrawerButton.classList.contains('top-menu-close')) {
          mobileNavigationMenu?.classList.remove('sub-menu-open');
          mobileMenuFooter?.classList.remove('hidden');
        }

        let navMenuNum = closeMobileMenuDrawerButton.getAttribute('close-drawer');
        for (var m = 0; m <= navDrawers.length; m++) {
          let childMobileMenuNum = navDrawers[m].getAttribute('drawer');
          if (childMobileMenuNum === navMenuNum) {
            navDrawers[m].classList.remove("nav-open"); 
            break;
          }
        } 
      })  
    }
  }


  //search

  let desktopSearchController = document.querySelector<HTMLSelectElement>('#desktop-search');
  let mobileSearchController = document.querySelector<HTMLSelectElement>('#mobile-search');
  let desktopSearch = document.querySelector<HTMLSelectElement>('.desktop-search');
  let desktopSearchInput = document.querySelector<HTMLSelectElement>('#desktop-search-input');


  //cart preview


  let cartPreviewController = document.querySelector<HTMLSelectElement>('#cart-icon-container');
  let cartPreview = document.querySelector<HTMLSelectElement>('#cart-preview');
  let cartArrow = document.querySelector<HTMLSelectElement>('.cart-arrow');

  if (cartPreviewController) {
    cartPreviewController.addEventListener("click", toggleCartPreview);
  }

  function toggleCartPreview() {
    if (cartPreview && cartArrow) {
      cartPreview.classList.toggle('show-preview');
      cartArrow.classList.toggle('show-arrow');
    }

    if (desktopSearch) {
      desktopSearch.classList.remove("show-search");
    }
  }


  // open and close search

  if (desktopSearchController != null) {

    desktopSearchController.addEventListener("click", toggleSearch);

  }

  if (mobileSearchController != null) {

    mobileSearchController.addEventListener("click", toggleSearch);

  }


  function toggleSearch() {

    if (desktopSearchInput) {
      console.log("Working");
      desktopSearchInput.focus();
    }

    if (desktopSearch != null) {
      desktopSearch.classList.toggle("show-search");
    }

    if (cartPreview && cartArrow) {
      cartPreview.classList.remove('show-preview');
      cartArrow.classList.remove('show-arrow');
    }
  }

  // Read More Buttons


  let readMoreButtons = document.querySelectorAll('.btn-read-more');
  let readMoreContentSections = document.querySelectorAll('.read-more-content');


  if (readMoreButtons) {
    [...readMoreButtons].forEach((readMoreButton) => {
      readMoreButton.addEventListener("click", () => {
        let btnSectionId = readMoreButton.getAttribute('section-id');

        if (readMoreButton.innerHTML === 'Read More') {
          readMoreButton.innerHTML = 'Read Less';
        }
        else if (readMoreButton.innerHTML === 'Read Less') {
          readMoreButton.innerHTML = 'Read More';
        }

        for (var l = 0; l < readMoreContentSections.length; l++) {
          let currentreadMoreContentSection = readMoreContentSections[l];
          let sectionId = currentreadMoreContentSection.getAttribute('section-id');

          if (sectionId === btnSectionId) {
            currentreadMoreContentSection.classList.toggle('show-content');
          }
        }
      })
    })
  }

  const glideHomeContainer = document.querySelector('.glide-homeslider');

  if (glideHomeContainer) {
    const homeSliderGlider = new Glide(glideHomeContainer, {
      gap: 0,
      perView: 1,
      startAt: 0,
      autoplay: 10000,
      focusAt: 'center',
      type: 'carousel'
    });

    let homeSlider = document.querySelector('.glide-homeslider');
    homeSliderGlider.on('build.after', function () {
      if (homeSlider) {
        homeSlider.classList.remove('hide-slider');
      }
    })

    homeSliderGlider.mount();
  }

  // Article Filters

  let articleFilterSelect = document.querySelector<HTMLSelectElement>('#select-filter');
  let filterContainer = document.querySelector('.selected-filter');
  let selectedFilter = document.querySelector('#selected-article-filter');
  let windowHref = window.location.href.split('/tagged/');
  let tagName = windowHref[1];
  if (tagName !== undefined) {
    tagName = tagName.replaceAll('-', ' ');
  }

  articleFilterSelect?.addEventListener("change", () => {
    ;
    let tagHandle = articleFilterSelect?.value;
    if (tagHandle !== '') {
      console.log(tagHandle);
      window.location.href = "" + tagHandle;
    }
  })

  if (selectedFilter && tagName !== undefined && filterContainer) {
    filterContainer.classList.remove('d-none');
    let tagNameSplit = tagName.split(' ');
    let tagNameCapitalized;
    for (var x = 0; x < tagNameSplit.length; x++) {
      let currentTagName = tagNameSplit[x][0].toUpperCase() + tagNameSplit[x].substr(1);
      if (x !== 0) {
        tagNameCapitalized = tagNameCapitalized + ' ' + currentTagName;
      }
      else {
        tagNameCapitalized = currentTagName;
      }
    }
    selectedFilter.innerHTML = tagNameCapitalized;

  }
})();